import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Affaire, PageResponse } from '../models/models';

@Injectable({
  providedIn: 'root'
})
export class AffaireService {
  private readonly apiUrl = `${environment.apiUrl}/affaires`;

  constructor(private http: HttpClient) {}

  getAffaires(search: string = '', page: number = 0, size: number = 10, sort: string = 'createdAt,desc', showArchived: boolean = false): Observable<PageResponse<Affaire>> {
    let params = new HttpParams()
      .set('search', search)
      .set('page', page.toString())
      .set('size', size.toString())
      .set('sort', sort)
      .set('showArchived', String(showArchived));
    return this.http.get<PageResponse<Affaire>>(this.apiUrl, { params });
  }

  createAffaire(affaire: Affaire): Observable<any> {
    return this.http.post(this.apiUrl, affaire);
  }

  getAffaireById(id: number): Observable<Affaire> {
    return this.http.get<Affaire>(`${this.apiUrl}/${id}`);
  }

  updateAffaire(id: number, affaire: Affaire): Observable<any> {
    return this.http.put(`${this.apiUrl}/${id}`, affaire);
  }

  deleteAffaire(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`);
  }

  canDeleteAffaire(id: number): Observable<boolean> {
    return this.http.get<boolean>(`${this.apiUrl}/${id}/can-delete`);
  }

  uploadFile(id: number, file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post(`${this.apiUrl}/${id}/files`, formData);
  }

  deleteFile(fileId: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/files/${fileId}`);
  }

  downloadFile(fileId: number): Observable<Blob> {
    return this.http.get(`${this.apiUrl}/files/${fileId}`, {
      responseType: 'blob'
    });
  }
}
